import { TARGET_LANGUAGES } from "./i18n-constants.mjs";

export { DEFAULT_LANGUAGE, TARGET_LANGUAGES } from "./i18n-constants.mjs";

export const RELEASED_TARGET_LANGUAGES = [
  "sv",
  "pl",
  "pt",
  "ja",
  "ko",
  "hi",
  "es",
  "fr",
  "de",
  "it",
  "zh",
] as readonly TargetLanguage[];
export const defaultLocale = "en" as const;
export const LOCALE_PATTERN = /^(en|es|de|fr|it|ja|ko|sv|pl|pt|hi|zh)(\/|$)/;

export const cmsLocales = ["en", ...TARGET_LANGUAGES] as const;
export const releasedLocales = ["en", ...RELEASED_TARGET_LANGUAGES] as readonly Locale[];
export type TargetLanguage = (typeof TARGET_LANGUAGES)[number];

export type Locale = (typeof locales)[number];
export const locales = ["en", ...TARGET_LANGUAGES] as const;

export const LANGUAGE_TO_LOCALE = {
  // Languages
  english: "en",
  hindi: "hi",
  spanish: "es",
  german: "de",
  french: "fr",
  italian: "it",
  japanese: "ja",
  korean: "ko",
  polish: "pl",
  swedish: "sv",
  portuguese: "pt",
  chinese: "zh",

  // Accents
  // English (en)
  jamaican: "en",
  filipino: "en",
  african: "en",
  american: "en",
  cockney: "en",
  country: "en",
  texas: "en",
  southern: "en",
  scottish: "en",
  pakistani: "en",
  york: "en",
  irish: "en",
  essex: "en",
  californian: "en",
  british: "en",
  canadian: "en",
  australian: "en",
  latino: "en",
  indian: "en",

  // Spanish (es)
  "latin-american": "es",
  castilian: "es",
  mexican: "es",
  argentine: "es",

  // French (fr)
  swiss: "fr",

  // German (de)
  bavarian: "de",

  // Hindi (hi)
  desi: "hi",

  // Swedish (sv)
  scandinavian: "sv",

  // Portuguese (pt)
  brazilian: "pt",
} as const satisfies Record<string, Locale>;

export function isReleasedLocale(value: unknown): value is Locale {
  return typeof value === "string" && (releasedLocales as readonly string[]).includes(value);
}

export function buildAlternateLanguages(
  baseUrl: string,
  slug: string,
  enabledLocales?: readonly string[] | null,
): Record<string, string> {
  const defaultUrl = `${baseUrl}${slug}`;
  const targetLocales =
    enabledLocales && enabledLocales.length > 0
      ? RELEASED_TARGET_LANGUAGES.filter(locale => enabledLocales.includes(locale))
      : RELEASED_TARGET_LANGUAGES;
  const includeEnglish = !enabledLocales || enabledLocales.length === 0 || enabledLocales.includes(defaultLocale);

  const localized = targetLocales.reduce<Record<string, string>>((acc, locale) => {
    acc[locale] = `${baseUrl}/${locale}${slug === "/" ? "" : slug}`;
    return acc;
  }, {});

  return {
    ...(includeEnglish && { [defaultLocale]: defaultUrl }),
    ...localized,
    "x-default": defaultUrl,
  };
}

export function getRegionLocale(locale: Locale): string {
  switch (locale) {
    case "en":
      return "en-us";
    case "hi":
      return "hi-in";
    case "es":
      return "es-es";
    case "de":
      return "de-de";
    case "fr":
      return "fr-fr";
    case "it":
      return "it-it";
    case "ja":
      return "ja-jp";
    case "ko":
      return "ko-kr";
    case "pt":
      return "pt-br";
    case "sv":
      return "sv-se";
    case "pl":
      return "pl-pl";
    case "zh":
      return "zh";
  }
}
